var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.survey)?_c('div',{staticStyle:{"width":"100%"}},[_c('survey',{ref:"el",attrs:{"survey":_vm.survey}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }